import LayoutV2 from './layouts/LayoutV2';
import Explore from './v2/Explore';
import ExploreApis from './v2/explore/ExploreApis';
import Workspace from './v2/workspace/Workspace';
import ApiProject from './v2/workspace/api-project/ApiProject';
import ExploreTables from './v2/explore/ExploreTables';
import ExploreDashboards from './v2/explore/ExploreDashboards';
import TableProject from './v2/components/TableProject';
import ApiKeyPageV2 from './v2/api-key/ApiKeyPageV2';
import { ApiUsageV2 } from './v2/api-key/ApiUsageV2';
import DashboardViewV2 from './v2/components/DashboadViewV2';
import DataSourceListPageV2 from './v2/workspace/DataSourceListPageV2';
import SearchResults from './v2/search/SearchResults';
import Upload from './modules/connectors/Upload';
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import AuthenticationPage from './v2/auth/Auth';
import Build from './v2/build/Build';
// import useAuth from './hooks/auth';
import { useEffect } from 'react';
import { isEmpty, startsWith } from 'lodash';
import { AuthState } from './modules/auth/AuthState';
import { useRecoilState } from 'recoil';
import { useCookies } from 'react-cookie';
import { AuthApi } from './api/client';
import ChoosePlan from './v2/onboarding/ChoosePlan';
import AddPaymentMethod from './v2/onboarding/AddPaymentMethod';
import Billing from './v2/billing/Billing';
import ImagePicker from './v2/image-upload/ImagePicker';

// This is the base Routes file for the product v2


function AuthRouter() {
  const navigate = useNavigate();
  const location = useLocation();
  const [auth, setAuth] = useRecoilState(AuthState);
  const [cookies] = useCookies(['auth']);

  useEffect(() => {
    const refreshAccessToken = async () => {
      const client = AuthApi();
      try {
        const resp = await client.postAuth();
        if (resp && resp.data.accessToken && resp.data.user?.id) {
          setAuth({
            accessToken: resp.data.accessToken,
            id: resp.data.user.id,
            name: resp.data.user.name,
            email: resp.data.user.email,
            profileImage: resp.data.user.profileImage,
            tenant: resp.data.user.tenant,
            defaultApiKey: resp.data.user.defaultApiKey,
            subscription: resp.data.subscription,
            whitelisted: resp.data.user.isInAllowList
          });
        } else {
          setAuth(null);
        }

        setTimeout(() => {

        }, 1);
      } catch (error) {
        setAuth(null);
      }
    };
    refreshAccessToken();
  }, []);

  useEffect(() => {
    const isAuthRoute = startsWith(location.pathname, '/v2/auth');
    if (!isAuthRoute && auth === null && isEmpty(cookies.auth)) {
      if (location.pathname.includes('community/dashboards')) {
        return;
      }
      const backParam = encodeURIComponent(location.pathname);
      navigate(`/v2/auth/login${backParam ? `?back=${backParam}` : ''}`);
    }

    if (auth?.subscription && auth.subscription.plan === 'free' && auth.subscription.planChosen === false) {
      if (location.pathname.includes('v2/onboarding')) {
        return;
      }
      navigate('/v2/onboarding/choose-plan');
    }
  }, [cookies.auth, auth, location.pathname]);

  return null;
}

// TODO: Extract this to a separate file
const SimpleAuth = ({
  children
}: {
  children?: React.ReactNode
}) => {
  // const [{ auth }] = useAuth()
  // if (auth?.tenant && auth?.tenant !== 'zettablock.com') {
  //   return <Navigate to="/my-workspace/" />
  // }

  return <div>
    <AuthRouter />
    {children || <Outlet />}
  </div>

}

export const ProductV2Routes = () => {
  return <Routes>
    
    <Route path='/auth/login' element={<AuthenticationPage type="login" />} />
    <Route path='/auth/register' element={<AuthenticationPage type="register" />} />
    <Route path='/auth/verify/:emailAddress' element={<AuthenticationPage type="verify" />} />

    <Route path="/" element={<SimpleAuth />}>
      <Route path="/upload" element={<ImagePicker onChange={() => {}} value='' />}></Route>
      <Route
        path="/onboarding/choose-plan"
        element={<ChoosePlan />}
      />
      <Route
        path="/onboarding/subscribe"
        element={<AddPaymentMethod />}
      />



      <Route path='/build' element={<Build />} />
      <Route path='/build/:id' element={<Build />} />

      <Route path='/' element={<LayoutV2 />}>
        <Route path='/billing' element={<Billing />} />

        <Route path='/data-sources' element={<DataSourceListPageV2 />} />
        <Route path='/search-results' element={<SearchResults />} />
        <Route path='/data-sources/type/:type' element={<Upload />} />

        <Route path='/explore' element={<Explore />} />
        <Route path='/explore/apis' element={<ExploreApis />} />
        <Route path='/explore/apis/:projectId/*' element={<ApiProject type="explore" />} />

        <Route path='/explore/tables' element={<ExploreTables />} />
        <Route path='/explore/tables/:projectId/*' element={<TableProject type="explore" />} />

        <Route path='/explore/dashboards' element={<ExploreDashboards />} />
        <Route path='/explore/dashboards/:dashboardId' element={<DashboardViewV2 />} />


        <Route path='/workspace' element={<Navigate to="/v2/workspace/apis" />} />
        <Route path='/workspace/apis/:projectId/*' element={<ApiProject type="workspace" />} />
        <Route path='/workspace/tables/:projectId/*' element={<TableProject type="workspace" />} />
        <Route path='/workspace/dashboards/:dashboardId' element={<DashboardViewV2 />} />
        <Route path='/workspace/*' element={<Workspace />} />

        <Route path="/api-key" element={<ApiKeyPageV2 />} />
        <Route path="/api-key/:apiKeyId" element={<ApiUsageV2 />} />

      </Route>

    </Route>
  </Routes>
}